import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function ProgressiveWebApps() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/5bcc1c4843d900105675dd139ef946f0800d9fbf-1381x548.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Progressive Web Apps</h1>
            <p style={{ marginBottom: '3.5rem' }}>Progressive web apps (PWA's) use modern web capabilities to deliver incredible mobile app experiences with no app stores or downloads required.</p>
            <h3>Apps Created for Online Success</h3>
            <p style={{ marginBottom: '3.5rem' }}>Progressive web apps integrate the best features and functionalities of mobile browser apps and native apps, so you get the benefits of both and can serve all users on all devices with a single platform. Our PWAs are highly optimized, reliable, discoverable, linkable, web-based, network-independent, progressive, and responsive. They can be easily found on search engines, used on any device and browser, and can be saved to a device's home screen for easy accessibility by simply sending a URL link and be used to deliver push notifications.</p>
            <p style={{ marginBottom: '3.5rem' }}>Advanced features, such as offline browsing, data analysis, and easy distribution channels provide users with the best experience and open the door for new business opportunities. Offline browsing capability, in particular, makes PWAs highly user- and conversion-friendly, because users can still interact with them when they are in an area with poor or no internet connectivity.</p>
            <h3>Why Consider Progressive Web Apps?</h3>
            <p style={{ marginBottom: '3.5rem' }}>PWA's are a popular choice amongst web users as they offer;</p>
            <ul style={{ listStyleType: 'square' }}>
              <li>Easy & quick installations</li>
              <li>User-friendly</li>
              <li>Always up-to-date</li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>Our professionally designed and developed PWAs provide an outstanding user experience, reliable performance & functionality, and free your business from the limitations of app stores.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/image.png`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default ProgressiveWebApps